// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/contribution-category-schema',
  type: 'object',
  required: [],
  properties: {
    contributionCategoryOrganisationId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    contributionCategoryId: {
      type: 'string',
      format: 'uuid',
      nullable: true,
    },
    contributionCategoryName: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
